import { setShowInOfficeUploadPatientFoundDetails } from "app/store/manualUpload/slice/manualUploadSlice";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import useAuthorization from "hooks/useAuthorization";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import InOfficePatientDetails from "../components/InOfficePatientDetails/InOfficePatientDetails";
import useInOfficeFileUpload from "../forms/fileUpload/useInOfficeFileUpload";

const InOfficePatientDetailsModal = ({ handlePatientSelect }) => {
  const dispatch = useDispatch();
  const {
    updatedAccountName,
    invalidAccountName,
    hasAccessToAccountInNoteFile,
    patientDeviceInformation,
    inOfficeUploadPatientDetails,
    isSearchingSimilarPatients,

    cancelFile,
    setUpdatedAccountName,
    handleInOfficePatientSelect,
  } = useInOfficeFileUpload({ handlePatientSelect });
  const {
    inOfficeUploadPatientDetails: { inOfficeData },
  } = useSelector((state) => state.manualUpload);

  const { checkHasAccountAccess, checkHasManufacturerAccess } =
    useAuthorization();

  const hasAccountAccess = checkHasAccountAccess(
    inOfficeData?.patientDeviceInformation?.clinic
  );
  const hasManufacturerAccess = checkHasManufacturerAccess(
    inOfficeData?.patientDeviceInformation?.manufacturer
  );

  const onClose = () => {
    cancelFile();
    dispatch(setShowInOfficeUploadPatientFoundDetails(false));
  };

  return (
    <div>
      <ModalWrapper
        show={true}
        showTitle={true}
        maxWidth="sm"
        showCloseIcon={true}
        headerStyle={{ padding: "4px 24px" }}
        onClose={onClose}
        title={`${
          inOfficeData.isExistingPatient ? "Patient Found" : "New Patient"
        }`}
        children={
          <InOfficePatientDetails
            isExistingPatient={inOfficeData.isExistingPatient}
            hasAccountAccess={hasAccountAccess}
            hasManufacturerAccess={hasManufacturerAccess}
            updatedAccountName={updatedAccountName}
            invalidAccountName={invalidAccountName}
            hasAccessToAccountInNoteFile={hasAccessToAccountInNoteFile}
            patientDeviceInformation={patientDeviceInformation}
            setUpdatedAccountName={setUpdatedAccountName}
            inOfficeUploadPatientDetails={inOfficeUploadPatientDetails}
          />
        }
        actionButtons={[
          {
            label: "Cancel",
            variant: "outlined",
            color: "secondary",
            onClick: onClose,
          },
          {
            label: "Proceed",
            variant: "contained",
            color: "secondary",
            onClick: handleInOfficePatientSelect,
            isLoading: isSearchingSimilarPatients,
            disabled:
              (inOfficeData.isExistingPatient &&
                ((hasAccessToAccountInNoteFile && !hasAccountAccess) ||
                  !hasManufacturerAccess)) ||
              (!hasAccessToAccountInNoteFile && !updatedAccountName),
          },
        ]}
      />
    </div>
  );
};

export default InOfficePatientDetailsModal;
